import React from "react";

const Price = ({ stars_event }) => {
  const renderIcon = () => "💵 ";
  const renderIcons = (num) => [...Array(num)].map(renderIcon);
  return <p>{renderIcons(stars_event)}</p>
};

export default Price;
